import { render, staticRenderFns } from "./CompList.vue?vue&type=template&id=539287e1&scoped=true&"
import script from "./CompList.vue?vue&type=script&lang=js&"
export * from "./CompList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539287e1",
  null
  
)

export default component.exports